// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"54590ebc","453":"7501bed3","455":"3da96d34","977":"ee69016d"}[chunkId] + ".chunk.js";
};